inputs-typeahead-dubble
  div(class="form-group row { error: opts.errors } { selected: opts.value != '' }")
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8.clearfix
      .row
        .col-12.col-md-6(each="{opts.items}")
          .item.form-group.clearfix
            .text-wrap(if="{ text != '' }")
              .text.align-middle { text }
              span.align-middle.btn.btn-danger.btn-outline-danger.btn-sm.btn-close.icon-btn(onClick="{parent.onClickRemoveBtn}")
                i.feather.icon-x
            input(type="hidden" name="{parent.opts.name}" value="{id}")
        .col-12.col-md-6
          inputs-without-label-typeahead(if="{areNotFull()}" tag-scope="{ this.tagScope }.typeahead" onSelect="{ this.onSelectItem }")
  script(type="typescript").
    this.mixin('inputs.typeahead-dubble');
  style(scoped).
    .text {
      display: inline-block;
      padding-top: calc(0.375rem + 1px);
      padding-bottom: calc(0.375rem + 1px);
      flex-grow: 5;
    }
    .text-wrap {
      display: flex;
    }
    .remove-wrap {
      width: 41px;
    }
